import React from 'react'
import { Navigate, Route, Routes, useLocation } from 'react-router-dom'

import AuthenticatedLayout from '../components/layouts/AuthenticatedLayout'
import ProtectedRoute from './ProtectedRoute'

import { useSelector } from 'react-redux'
import PatientEMR from '../pages/patient-profile/PatientEMR'
import PatientProfilingLayout from '../components/layouts/PatientProfilingLayout'

const Dashboard = React.lazy(() => import('../pages/Lab/Dashboard'))
const CriticalLabReports = React.lazy(() => import('../pages/Lab/CriticalLabReports'))
const QueueMonitor = React.lazy(() => import('../pages/QueueMonitorTable'))
const SampleCollection = React.lazy(() =>
  import('../pages/Lab/SampleCollection')
)
const ReceiveSample = React.lazy(() =>
  import('../pages/radiology/ReceiveSample')
)
const CancelledOrders = React.lazy(() =>
  import('../pages/radiology/CancelledOrders')
)
const RecivedSample = React.lazy(() => import('../pages/Lab/RecivedSample'))
const AddResult = React.lazy(() => import('../pages/Lab/AddResult'))
const UploadLabItemResults = React.lazy(() =>
  import('../pages/Lab/UploadLabItemResults/UploadLabItemResults')
)
const UploadExternalLabItemResults = React.lazy(() =>
  import('../pages/Lab/UploadExternalLabItemResults')
)
const BaladiyaOrderFormPage = React.lazy(() =>
  import('../pages/Lab/BaladiyaOrderFormPage')
)
const BaladiyaOrderFormsPage = React.lazy(() =>
  import('../pages/Lab/BaladiyaOrderFormsPage')
)
const ViewReceiveSample = React.lazy(() =>
  import('../pages/radiology/ViewReceiveSample')
)
const AddRadiologyResult = React.lazy(() =>
  import('../pages/radiology/AddRadiologyResult')
)
const UploadRadiologyResult = React.lazy(() =>
  import('../pages/radiology/UploadRadiologyResult')
)
const AddExternalRadiologyResult = React.lazy(() =>
  import('../pages/radiology/AddExternalRadiologyResult')
)
const UploadExternalRadiologyResult = React.lazy(() =>
  import('../pages/radiology/UploadExternalRadiologyResult')
)
const ApprovedResults = React.lazy(() =>
  import('../pages/radiology/ApprovedResults')
)
const RadiologySettings = React.lazy(() =>
  import('../pages/radiology/RadiologySettings')
)
const ExternalRadiologies = React.lazy(() =>
  import('../pages/radiology/ExternalRadiologies')
)
const RadiologyPricelistsList = React.lazy(() =>
  import('../pages/radiology/RadiologyPricelistsList')
)
const RadiologyEditPricelist = React.lazy(() =>
  import('../pages/radiology/RadiologyEditPricelist')
)
const RadiologyTest = React.lazy(() =>
  import('../pages/radiology/RadiologyTest')
)
const RadiologyTestComponent = React.lazy(() =>
  import('../pages/radiology/RadiologyTestComponent')
)
const CreateRadiologyTest = React.lazy(() =>
  import('../pages/radiology/CreateRadiologyTest')
)
const CreateRadiologyTestComponent = React.lazy(() =>
  import('../pages/radiology/CreateRadiologyTestComponent')
)
const RadiologyTracking = React.lazy(() =>
  import('../pages/radiology/RadiologyTracking')
)
const LabViewSampleCollection = React.lazy(() =>
  import('../pages/Lab/LabViewSampleCollection')
)
const AddResultDetailsPage = React.lazy(() =>
  import('../pages/Lab/AddResultDetailsPage')
)
const PendingReport = React.lazy(() => import('../pages/Lab/PendingReport'))
const ApprovedReport = React.lazy(() => import('../pages/Lab/ApprovedReport'))
const RejectedReport = React.lazy(() => import('../pages/Lab/RejectedReport'))
const LabTracking = React.lazy(() => import('../pages/Lab/LabTracking'))
const LabTatStats = React.lazy(() => import('../pages/Lab/LabTatStats'))
const RadiologyTatStats = React.lazy(() => import('../pages/radiology/RadiologyTatStats'))
// const LabTatKpiDashboard = React.lazy(() => import('../pages/Lab/LabTatKpiDashboard'))
// const RadiologyTatKpiDashboard = React.lazy(() => import('../pages/radiology/RadiologyTatKpiDashboard'))
const CancelOrder = React.lazy(() => import('../pages/Lab/CancelOrder'))
const LabSettings = React.lazy(() => import('../pages/Lab/LabSettings'))
const PayersList = React.lazy(() => import('../pages/Lab/PayersList'))
const PricelistsList = React.lazy(() => import('../pages/Lab/PricelistsList'))
const EditPricelist = React.lazy(() => import('../pages/Lab/EditPricelist'))
const AddExternalResult = React.lazy(() =>
  import('../pages/Lab/AddExternalResult')
)
const AddExternalResultDetailPage = React.lazy(() =>
  import('../components/lab/AddExternalResult/AddExternalResultDetailPage')
)
const LabTests = React.lazy(() => import('../pages/Lab/LabTests'))
const LabTestComponents = React.lazy(() =>
  import('../pages/Lab/LabTestComponents')
)
const ManageLabTestComponent = React.lazy(() =>
  import('../pages/Lab/ManageLabTestComponent')
)
const ViewLabTestComponent = React.lazy(() =>
  import('../pages/Lab/ViewLabTestComponent')
)
const ManageLabTest = React.lazy(() => import('../pages/Lab/ManageLabTest'))
const ViewLabTest = React.lazy(() => import('../pages/Lab/ViewLabTest'))
const LabSpecimens = React.lazy(() => import('../pages/Lab/LabSpecimens'))
const LabProfileAssignment = React.lazy(() =>
  import('../pages/Lab/LabProfileAssignment')
)
const LabProfile = React.lazy(() => import('../pages/Lab/LabProfile'))
const ExternalLabs = React.lazy(() => import('../pages/Lab/ExternalLabs'))
const ReceivingManagement = React.lazy(() =>
  import('../pages/Lab/ReceivingManagement')
)
const ReportsManagement = React.lazy(() =>
  import('../pages/Lab/ReportsManagement')
)
const LabOrdersList = React.lazy(() => import('../pages/Lab/LabOrdersList'))
const RadiologyOrdersList = React.lazy(() =>
  import('../pages/radiology/RadiologyOrdersList')
)
const PharmacyOrdersList = React.lazy(() =>
  import('../pages/Pharmacy/PharmacyOrdersList')
)
const BusinessSettings = React.lazy(() =>
  import('../pages/Settings/BusinessSettings')
)
const Roles = React.lazy(() => import('../pages/Lab/Roles'))
const RolePermissions = React.lazy(() => import('../pages/Lab/RolePermissions'))
const Users = React.lazy(() => import('../pages/Lab/Users'))
const DoctoNotes = React.lazy(() =>
  import('../pages/patient-profile/DoctorNotes')
)
const Allergies = React.lazy(() =>
  import('../pages/patient-profile/Allergies')
)
const OrdersTracking = React.lazy(() =>
  import('../pages/patient-profile/OrdersTracking')
)
const LabEditOrder = React.lazy(() => import('../pages/Lab/EditOrder'))
const RadiologyEditOrder = React.lazy(() =>
  import('../pages/radiology/EditOrder')
)
const UpdateRadiologyResult = React.lazy(() =>
  import('../pages/radiology/UpdateRadiologyResult')
)
const VisitStatusLogsPage = React.lazy(() =>
  import('../pages/visitStatus/VisitStatusLogsPage')
)
const LabOrdersLogs = React.lazy(() =>
  import('../pages/ordersLogs/LabOrdersLogs')
)
const RadiologyOrdersLogs = React.lazy(() =>
  import('../pages/ordersLogs/RadiologyOrdersLogs')
)
const PatientOrders = React.lazy(() =>
  import('../pages/PatientOrders/PatientOrders')
)
const OrderManagement = React.lazy(() =>
  import('../pages/OrderManagement/OrderManagement')
)
const LabManualResultDocuments = React.lazy(() =>
  import('../pages/Lab/ManualResultDocuments')
)
const RadiologyManualResultDocuments = React.lazy(() =>
  import('../pages/radiology/ManualResultDocuments')
)

const PatientManualResults = React.lazy(() =>
  import('../pages/patient-profile/PatientManualResults')
)

const ReportsStatistics = React.lazy(() =>
  import('../pages/Lab/ReportsStatistics')
)
const OrderReportPage = React.lazy(() =>
  import('../pages/Lab/OrderReportPage')
)
const ItemReportPage = React.lazy(() =>
  import('../pages/Lab/ItemReportPage')
)
const ItemStatusStatisticsReportPage = React.lazy(() =>
  import('../pages/Lab/ItemStatusStatisticsReportPage')
)
const CategoryWiseReportPage = React.lazy(() =>
  import('../pages/Lab/CategoryWiseReportPage')
)
const TatOrderedItemReportPage = React.lazy(() =>
  import('../pages/Lab/TatOrderedItemReportPage')
)
const TatDelayedDetailReportPage = React.lazy(() =>
  import('../pages/Lab/TatDelayedDetailReportPage')
)
const TatDepartmentItemsReportPage = React.lazy(() =>
  import('../pages/Lab/TatDepartmentItemsReportPage')
)
const TatAverageItemReportPage = React.lazy(() =>
  import('../pages/Lab/TatAverageItemReportPage')
)

const AuthenticatedRoutes = () => {
  const { user } = useSelector(state => state?.auth)

  const routesConfig = [
    {
      path: '/dashboard',
      component: <Dashboard />,
      serviceIds: [1, 2],
      module: 'dashboard'
    },
    {
      path: '/critical-reports',
      component: <CriticalLabReports />,
      serviceIds: [1],
      module: 'report'
    },
    {
      path: '/queue-monitor',
      component: <QueueMonitor />,
      serviceIds: [1, 2],
      module: 'dashboard'
    },
    {
      path: '/receiving',
      component: <ReceivingManagement />,
      serviceIds: [1],
      module: 'sample'
    },
    {
      path: '/reports',
      component: <ReportsManagement />,
      serviceIds: [1],
      module: 'report'
    },
    {
      path: '/lab/statistics',
      component: <ReportsStatistics />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/order',
      component: <OrderReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/item',
      component: <ItemReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/item-status-statistics',
      component: <ItemStatusStatisticsReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/category-wise',
      component: <CategoryWiseReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/tat/ordered-items',
      component: <TatOrderedItemReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/tat/delayed-details',
      component: <TatDelayedDetailReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/tat/departments',
      component: <TatDepartmentItemsReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/lab/statistics/tat/average-items',
      component: <TatAverageItemReportPage />,
      serviceIds: [1],
      module: 'lab_statistics'
    },
    {
      path: '/radiology/statistics',
      component: <ReportsStatistics service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/item-status-statistics',
      component: <ItemStatusStatisticsReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/category-wise',
      component: <CategoryWiseReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/tat/ordered-items',
      component: <TatOrderedItemReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/tat/delayed-details',
      component: <TatDelayedDetailReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/tat/departments',
      component: <TatDepartmentItemsReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/radiology/statistics/tat/average-items',
      component: <TatAverageItemReportPage service='radiology' />,
      serviceIds: [2],
    },
    {
      path: '/sample-collection',
      component: <SampleCollection />,
      serviceIds: [1],
      module: 'sample'
    },
    // {
    //   path: "/view-sample-collection/:orderNumber",
    //   component: <LabViewSampleCollection />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    {
      path: '/receive-order',
      component: <ReceiveSample />,
      serviceIds: [2],
      module: 'order'
    },
    {
      path: '/cancelled-orders',
      component: <CancelledOrders />,
      serviceIds: [2],
      module: 'cancel'
    },
    // {
    //   path: "/recived-sample",
    //   component: <RecivedSample />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    // {
    //   path: "/add-result",
    //   component: <AddResult />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    {
      path: '/add-result/:orderNumber',
      component: <UploadLabItemResults />,
      serviceIds: [1],
      permission: 'result.create'
    },
    {
      path: '/orders/:orderId/forms',
      component: <BaladiyaOrderFormsPage />,
      serviceIds: [1, 2],
    },
    {
      path: '/baladiya-medical-examination',
      component: <BaladiyaOrderFormPage />,
      serviceIds: [1, 2],
    },
    {
      path: '/driving-medical-examination',
      component: <BaladiyaOrderFormPage />,
      serviceIds: [1, 2],
    },
    {
      path: '/add-external-result',
      component: <AddExternalResult />,
      serviceIds: [1],
      permission: 'external_result.view'
    },
    // {
    //   path: "/add-external-result-details",
    //   component: <AddExternalResultDetailPage />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    {
      path: '/upload-external-lab-result/:orderNumber',
      component: <UploadExternalLabItemResults />,
      serviceIds: [1],
      permission: 'result.create'
    },
    // {
    //   path: "/add-result-details",
    //   component: <AddResultDetailsPage />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    // {
    //   path: "/pending-reports",
    //   component: <PendingReport />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    // {
    //   path: "/approved-reports",
    //   component: <ApprovedReport />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    // {
    //   path: "/rejected-reports",
    //   component: <RejectedReport />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    // {
    //   path: "/rejected-reports",
    //   component: <RejectedReport />,
    //   serviceIds: [1],
    //   permission: "get",
    // },
    {
      path: '/lab/tracking',
      component: <LabTracking />,
      serviceIds: [1],
      module: 'history'
    },
    {
      path: '/visit-status-logs',
      component: <VisitStatusLogsPage />,
      serviceIds: [1],
      module: 'visit_status'
    },
    {
      path: '/lab/orders-logs',
      component: <LabOrdersLogs />,
      serviceIds: [1],
      module: 'history'
    },
    {
      path: '/lab/tracking',
      component: <LabTracking />,
      serviceIds: [1],
      module: 'history'
    },
    {
      path: '/lab/tat-stats',
      component: <LabTatStats />,
      serviceIds: [1],
      module: 'history'
    },
    {
      path: '/radiology/tat-stats',
      component: <RadiologyTatStats />,
      serviceIds: [2],
      module: 'history'
    },
    // {
    //   path: '/lab/tat-kpi-dashboard',
    //   component: <LabTatKpiDashboard />,
    //   serviceIds: [1],
    //   module: 'history'
    // },
    // {
    //   path: '/radiology/tat-kpi-dashboard',
    //   component: <RadiologyTatKpiDashboard />,
    //   serviceIds: [2],
    //   module: 'history'
    // },
    {
      path: '/visit-status-logs',
      component: <VisitStatusLogsPage />,
      serviceIds: [1],
      module: 'visit_status'
    },
    // {
    //   path: '/lab/orders-logs',
    //   component: <LabOrdersLogs />,
    //   serviceIds: [1],
    //   module: 'history'
    // },
    {
      path: '/patient-orders',
      component: <PatientOrders />,
      serviceIds: [1, 2],
      module: 'history'
    },
    {
      path: '/order-management',
      component: <OrderManagement />,
      serviceIds: [1, 2],
      modules: ['order', 'cancel', 'history']
    },
    {
      path: '/patient-profile/lab/tracking',
      component: <LabTracking />,
      serviceIds: [1, 2],
      module: 'history'
    },
    {
      path: '/lab/cancelled-orders',
      component: <CancelOrder />,
      serviceIds: [1],
      module: 'cancel'
    },
    {
      path: '/lab/settings',
      component: <LabSettings />,
      serviceIds: [1]
    },
    {
      path: '/radiology/settings',
      component: <RadiologySettings />,
      serviceIds: [2]
    },
    {
      path: '/lab/business-settings',
      component: <BusinessSettings />,
      serviceIds: [1]
    },
    {
      path: '/radiology/business-settings',
      component: <BusinessSettings />,
      serviceIds: [2]
    },
    {
      path: '/lab/tests',
      component: <LabTests />,
      serviceIds: [1],
      module: 'lab_test'
    },
    {
      path: '/lab/test-components',
      component: <LabTestComponents />,
      serviceIds: [1],
      module: 'lab_test_component'
    },
    {
      path: '/lab/test-components/create',
      component: <ManageLabTestComponent />,
      serviceIds: [1],
      module: 'lab_test_component'
    },
    {
      path: '/lab/test-components/edit/:id',
      component: <ManageLabTestComponent />,
      serviceIds: [1],
      module: 'lab_test_component'
    },
    {
      path: '/lab/test-components/view/:id',
      component: <ViewLabTestComponent />,
      serviceIds: [1],
      module: 'lab_test_component'
    },
    {
      path: '/lab/tests/create',
      component: <ManageLabTest />,
      serviceIds: [1],
      module: 'lab_test'
    },
    {
      path: '/lab/tests/edit/:id',
      component: <ManageLabTest />,
      serviceIds: [1],
      module: 'lab_test'
    },
    {
      path: '/lab/tests/view/:id',
      component: <ViewLabTest />,
      serviceIds: [1],
      module: 'lab_test'
    },
    {
      path: '/lab/specimens',
      component: <LabSpecimens />,
      serviceIds: [1],
      module: 'specimen'
    },
    {
      path: '/lab/profile-assignment',
      component: <LabProfileAssignment />,
      serviceIds: [1],
      module: 'profile'
    },
    {
      path: '/lab/profile',
      component: <LabProfile />,
      serviceIds: [1],
      module: 'profile'
    },
    {
      path: '/lab/external-labs',
      component: <ExternalLabs />,
      serviceIds: [1],
      module: 'external_lab'
    },
    {
      path: '/lab/payers',
      component: <PayersList />,
      serviceIds: [1],
      adminOnly: true
    },
    {
      path: '/radiology/pricelists',
      component: <RadiologyPricelistsList />,
      serviceIds: [2]
    },
    {
      path: '/radiology/pricelist/edit',
      component: <RadiologyEditPricelist />,
      serviceIds: [2],
      adminOnly: true
    },
    {
      path: '/lab/pricelists',
      component: <PricelistsList />,
      serviceIds: [1]
    },
    {
      path: '/lab/pricelists/edit',
      component: <EditPricelist />,
      serviceIds: [1],
      adminOnly: true
    },
    {
      path: '/lab/roles',
      component: <Roles serviceId={1} />,
      serviceIds: [1],
      module: 'role'
    },
    {
      path: '/lab/roles/:id/permissions',
      component: <RolePermissions serviceId={1} />,
      serviceIds: [1],
      module: 'role'
    },
    {
      path: '/radiology/roles',
      component: <Roles serviceId={2} />,
      serviceIds: [2],
      module: 'role'
    },
    {
      path: '/radiology/roles/:id/permissions',
      component: <RolePermissions serviceId={2} />,
      serviceIds: [2],
      module: 'role'
    },
    {
      path: '/lab/users',
      component: <Users serviceId={1} />,
      serviceIds: [1],
      module: 'user'
    },
    // {
    //   path: "/view-receive-sample/:id",
    //   component: <ViewReceiveSample />,
    //   serviceIds: [2],
    //   permission: "get",
    // },
    {
      path: '/add-radiology-result',
      component: <AddRadiologyResult />,
      serviceIds: [2],
      module: 'result'
    },
    {
      path: '/add-external-radiology-result',
      component: <AddExternalRadiologyResult />,
      serviceIds: [2],
      permission: 'external_result.view'
    },
    {
      path: '/upload-radiology-result/:id',
      component: <UploadRadiologyResult />,
      serviceIds: [2],
      module: 'result'
    },
    {
      path: '/upload-external-radiology-result/:id',
      component: <UploadExternalRadiologyResult />,
      serviceIds: [2],
      module: 'result'
    },
    {
      path: '/approved-results',
      component: <ApprovedResults />,
      serviceIds: [2],
      module: 'approve'
    },
    {
      path: '/radiology/settings',
      component: <RadiologySettings />,
      serviceIds: [2]
    },
    {
      path: '/radiology/external-radiologies',
      component: <ExternalRadiologies />,
      serviceIds: [2],
      permission: 'external_radiology.view'
    },
    {
      path: '/radiology/test',
      component: <RadiologyTest />,
      serviceIds: [2],
      module: 'test'
    },
    {
      path: '/radiology/test-components',
      component: <RadiologyTestComponent />,
      serviceIds: [2],
      module: 'test_component'
    },
    {
      path: '/radiology/test/create',
      component: <CreateRadiologyTest />,
      serviceIds: [2],
      module: 'test'
    },
    {
      path: '/radiology/test-components/create',
      component: <CreateRadiologyTestComponent />,
      serviceIds: [2],
      module: 'test_component'
    },
    {
      path: '/radiology/tracking',
      component: <RadiologyTracking />,
      serviceIds: [2],
      module: 'history'
    },
    {
      path: '/radiology/orders-logs',
      component: <RadiologyOrdersLogs />,
      serviceIds: [2],
      module: 'history'
    },
    {
      path: '/patient-profile/radiology/tracking',
      component: <RadiologyTracking />,
      serviceIds: [2, 1],
      module: 'history'
    },
    {
      path: '/his/patient-profile/lab/orders-list',
      component: <LabOrdersList />,
      serviceIds: [1, 2],
      module: 'history'
    },
    {
      path: '/his/patient-profile/radiology/orders-list',
      component: <RadiologyOrdersList />,
      serviceIds: [2, 1],
      module: 'history'
    },
    {
      path: '/his/patient-profile/pharmacy/orders-list',
      component: <PharmacyOrdersList />,
      serviceIds: [1, 2],
      module: 'history'
    },
    {
      path: '/radiology/users',
      component: <Users serviceId={2} />,
      serviceIds: [2],
      module: 'user'
    },
    {
      path: '/his/patient-profile/allergies',
      component: <Allergies />,
      serviceIds: [2, 1],
      module: 'profile'
    },
    {
      path: '/his/patient-profile/manual-lab-results',
      component: <PatientManualResults documentType='Lab' />,
      serviceIds: [1, 2],
      module: 'result'
    },
    {
      path: '/his/patient-profile/manual-radiology-results',
      component: <PatientManualResults documentType='Radiology' />,
      serviceIds: [1, 2],
      module: 'result'
    },
    {
      path: '/his/patient-profile/emr',
      component: <PatientEMR />,
      serviceIds: [2, 1],
      module: 'profile'
    },
    {
      path: '/his/patient-profile/doctor-notes',
      component: <DoctoNotes />,
      serviceIds: [2, 1],
      module: 'profile'
    },
    {
      path: '/his/patient-profile/orders-tracking',
      component: <OrdersTracking />,
      serviceIds: [2, 1],
      module: 'history'
    },
    {
      path: '/lab/edit-order',
      component: <LabEditOrder />,
      serviceIds: [1],
      module: 'order'
    },
    {
      path: '/radiology/edit-order',
      component: <RadiologyEditOrder />,
      serviceIds: [2],
      module: 'order'
    },
    {
      path: '/update-radiology-result/:id',
      component: <UpdateRadiologyResult />,
      serviceIds: [2],
      permission: 'result.update'
    },
    {
      path: '/lab/manual-result-documents',
      component: <LabManualResultDocuments />,
      serviceIds: [1],
      permission: 'result.view'
    },
    {
      path: '/radiology/manual-result-documents',
      component: <RadiologyManualResultDocuments />,
      serviceIds: [2],
      permission: 'result.view'
    }
  ]

  const location = useLocation()
  const path = location.pathname
  const LayoutWrapper = path?.includes('/patient-profile')
    ? PatientProfilingLayout
    : AuthenticatedLayout

  return (
    <LayoutWrapper>
      <Routes>
        {routesConfig.map(
          ({ path, component, serviceIds, permission, module, modules, adminOnly }) => (
            <Route
              key={path}
              path={path}
              element={
                <ProtectedRoute
                  serviceIds={serviceIds}
                  permission={permission}
                  module={module}
                  modules={modules}
                  adminOnly={adminOnly}
                >
                  {component}
                </ProtectedRoute>
              }
            />
          )
        )}
        <Route path='*' element={<Navigate to={'/dashboard'} replace />} />
      </Routes>
    </LayoutWrapper>
  )
}

export default AuthenticatedRoutes
